import { Button } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import styles from "./Modal.module.css";
import { StyledDialog } from "./StyledDialog";

// properties that is to be added
// isModalOpen - Modal open or not
// setIsModalOpen - to change the state ofn the modal
// businessProcess - Additional business functionalities , non mandatory
// modalWidth - width of the screen , if not provided it is sm
// title - Title of the screen , if not provided it is "Alert"
// type - Can be Ok , Ok Cancel or Delete Cancel

function TermsAndConditionModal(props) {
  const { t } = useTranslation("common");

  const handleAgree = (event, reason) => {
    event.stopPropagation();
    // when we have clicked outside the modal the screen should close and  not Call on Agree method
    if (reason && reason === "backdropClick") return;

    // call the additional methods also if present
    if (props.onAgreed) {
      props.onAgreed();
    }
    // set close state as false , to close the dialog
    props.setIsModalOpen(false);
  };

  const handleClose = (event) => {
    event.stopPropagation();

    // set close state as false , to close the dialog
    props.setIsModalOpen(false);

    // call the additional methods also if present
    if (props.onTacClose) {
      props.onTacClose();
    }
  };

  // if the modal width is not provided sm is taken as the width else modal width is returned as width
  // widths that can be provided are xs, sm, md, lg , xl
  const getModalWidth = () => {
    if (props.modalWidth != null && props.modalWidth !== undefined) {
      return props.modalWidth;
    } else {
      return "sm";
    }
  };

  return (
    <>
      {/* Dialog window which has open property to indicate if screen is open or not,
            on close function , actions to be handled on close
       */}
      <StyledDialog
        open={props.isModalOpen}
        onClose={(event) => handleClose(event)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={getModalWidth()}
      >
        {/* Title will be provided in props , if not provided "Alert" will be shown as the title
         */}
        <DialogTitle className={styles.modaltitle} id="alert-dialog-title">
          {props.title ? t(props.title) : t("modal.alertModalTitle")}
        </DialogTitle>

        {/* All the content of the dialog will be displayed here */}
        <DialogContent className={styles.modalcontent} sx={{ mt: 2 }}>
          {props.children}
        </DialogContent>

        <DialogActions className={styles.modalfooter}>
          <Button
            className="btn shadow-none cancel_btn cursor_pointer"
            onClick={(event) => handleClose(event, "click")}
          >
            {t("modal.cancel")}
          </Button>
          <Button
            className="btn shadow-none ok_btn cursor_pointer"
            onClick={(event) => handleAgree(event, "click")}
          >
            {t("alertAction.iAgree")}
          </Button>
        </DialogActions>
      </StyledDialog>
    </>
  );
}

export default TermsAndConditionModal;
